// @flow

import { type Context, createContext } from 'react'

export type Props = {
    pageKey: string,
    pagePath: string,
}

const defaultContext: Props = {
    pageKey: 'top',
    pagePath: '/',
}

export default (createContext(defaultContext): Context<Props>)
